import "@babel/polyfill";
import "mutationobserver-shim";
import Vue from "vue";
import "./plugins/bootstrap-vue";
import "./plugins/axios";
import Loading from "vue-loading-overlay";
import VModal from "vue-js-modal";
import VueScreen from "vue-screen";

import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import locale from "./mixins/locale";

// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

// Init plugin
Vue.use(VModal);

Vue.use(Loading, {
  width: 128,
  height: 128,
  color: "blue",
  loader: "bars",
  canCancel: true,
});

Vue.use(VueScreen, "bootstrap");
Vue.mixin(locale);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
